import script from "./questionnaire-success.vue?vue&type=script&lang=ts&setup=true"
export * from "./questionnaire-success.vue?vue&type=script&lang=ts&setup=true"

import "./questionnaire-success.vue?vue&type=style&index=0&id=4cbcd3d7&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cbcd3d7"]])

export default __exports__